import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  SegmentDefinition,
  SegmentPreviewResponse
} from "../../marketing.types";

export const requestGetSegmentPreview = async (
  definition: SegmentDefinition
): Promise<SegmentPreviewResponse> => {
  return await instance.post(ApiRoutesMarketing.SegmentsPreview, definition);
};
